export default "__VITE_ASSET__DX0h0xr2__"